import React, { useEffect, useState } from 'react'
import Comment from './comment'
import { ContainerWrap } from './comment.style'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../mobx-store/context'
import { Spin } from 'antd'
import CustomPagination
  from '../../../../components/common/Pagination/pagination'
import { DocumentsPlaceholder } from '../right.style'

const CommentContainer = observer(({ grey, isReplied, legislative }) => {
  const store = useStore()
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (legislative)
      store.loadComments(legislative, '1', () => setLoading(false))
  }, [legislative])

  if (loading) return <Spin/>

  if (!store.comments.results) return null

  const comments = store.comments.results

  return (
    <ContainerWrap>
      {!comments.length &&
      <DocumentsPlaceholder
        style={{
          marginTop: 15,
          borderBottom: '1px solid #bbb',
          paddingBottom: 15,
        }}
      >
        There are no comments associated with this item yet.
      </DocumentsPlaceholder>}

      {comments.map((item, index) => (
        <Comment
          item={item}
          legislative={legislative}
          parentId={item.id}
          grey={index % 2 === 0}
        />
      ))}
      <CustomPagination
        total={store.comments.count}
        pageSize={'5'}
        current={page}
        onChange={(page) => {
          store.loadComments(legislative, page)
          setPage(page)
        }}
      />
    </ContainerWrap>
  )
})

export default CommentContainer
